<template>
  <component :is="pageName" :sn="sn" :deviceType="deviceType"></component>
</template>

<script>
import FCBR100S1 from './fcbr-100s1';

export default {
  components: {
    FCBR100S1
  },
  props: {
    sn: String,
    deviceType: String
  },
  computed: {
    pageName() {
      if (!this.deviceType) return '';
      return this.deviceType.replace(/-_/g, '').toUpperCase();
    }
  },
  created() {
    if (!this.pageName) {
      console.log('参数有误');
    }
  }
};
</script>

<style lang="scss"></style>
